import React, { useState, Fragment } from 'react';
import {
  IonList,
  IonLoading,
  IonSearchbar,
  IonContent,
  IonItem,
  IonThumbnail,
  IonLabel,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
  IonAlert,
} from '@ionic/react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/inventoryActions';
import _ from 'lodash';

import NoData from '../components/NoData';

const InventoryContainer: React.FC = (props: any) => {
  const { list, ordersList, updatedItems, user } = props;
  let filteredList = list;
  const [searchText, setSearchText] = useState<string>();
  const [showAlert1, setShowAlert1] = useState<any>({
    state: false,
    targetItem: {},
  });
  const [showDelErrorAlert, setDelErrorShowAlert] = useState(false);

  if (updatedItems === false) {
    props.onGetItems(user.email);
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  if (searchText) {
    filteredList = list.filter((item: any) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  setTimeout(() => {
    props.onResetStatus();
  }, 3000);

  return (
    <Fragment>
      <IonSearchbar
        className="search"
        value={searchText}
        onIonChange={(e) => setSearchText(e.detail.value!)}
      ></IonSearchbar>
      <IonContent>
        <IonList>
          {_.isEmpty(filteredList) && <NoData />}
          {filteredList.map((item: any) => (
            <IonItemSliding key={item._id}>
              <IonItem routerLink={'/item/' + item._id}>
                <IonThumbnail slot="start" border-radius="0">
                  <img src={item.imageURL} alt="item" />
                </IonThumbnail>
                <IonLabel>
                  <h4>
                    <b>
                      <p>{item.name}</p>
                    </b>
                  </h4>
                  <h4>
                    <p>KES {item.price}</p>
                  </h4>
                  <p>{item.quantity_available} in stock</p>
                </IonLabel>
              </IonItem>

              <IonItemOptions side="end">
                <IonItemOption
                  color="danger"
                  onClick={() => {
                    let found: boolean = false;

                    ordersList.forEach((order: any) => {
                      let i;
                      for (i = 0; i < order.orderItems.length; i++) {
                        if (order.orderItems[i].itemId === item._id) {
                          found = true;
                          break;
                        }
                      }
                    });

                    console.log(ordersList, item._id, found);

                    if (found) {
                      setDelErrorShowAlert(true);
                    } else {
                      setShowAlert1({ state: true, targetItem: item });
                    }
                  }}
                >
                  Delete
                </IonItemOption>
              </IonItemOptions>
            </IonItemSliding>
          ))}
        </IonList>
        <IonAlert
          isOpen={showDelErrorAlert}
          onDidDismiss={() => setDelErrorShowAlert(false)}
          header={'Item can not be deleted'}
          message={'Item is currently in an Order'}
          buttons={['Okay']}
        />
        <IonAlert
          isOpen={showAlert1.state}
          onDidDismiss={() => setShowAlert1({ state: false, targetItem: {} })}
          header={'Delete this item?'}
          message={'This action can not be undone'}
          buttons={[
            'No',
            {
              text: 'Yes',
              handler: () => {
                props.onRemoveItem({
                  itemId: showAlert1.targetItem._id,
                  imageURL: showAlert1.targetItem.imageURL,
                  userId: showAlert1.targetItem.userId,
                });
              },
            },
          ]}
        />
      </IonContent>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.inventoryReducer.list,
    ordersList: state.ordersReducer.list,
    updatedItems: state.inventoryReducer.updatedItems,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onRemoveItem: (payload: {}) => dispatch(actionCreator.removeItem(payload)),
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
    onGetItems: (payload: {}) => dispatch(actionCreator.getItems(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryContainer);
